import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800/10 bg-slate-950 py-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-10 text-slate-300">
          {/* Column 1 */}
          <div>
            <h3 className="text-white font-semibold text-lg">BuildBright</h3>
            <p className="text-sm mt-2 leading-relaxed text-slate-400">
              Professional roofing, solar, and landscaping services nationwide.
            </p>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">
              Services
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/#/services?service=roofing" className="hover:text-white">
                  Roofing
                </a>
              </li>
              <li>
                <a href="/#/services?service=solar" className="hover:text-white">
                  Solar
                </a>
              </li>
              <li>
                <a
                  href="/#/services?service=landscaping"
                  className="hover:text-white"
                >
                  Landscaping
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">
              Company
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/#/terms" className="hover:text-white">
                  Terms of Use
                </a>
              </li>
              <li>
                <a href="/#/privacy" className="hover:text-white">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/#/contact" className="hover:text-white">
                  Contact
                 </a>
              </li>
           </ul>
          </div>

          {/* Column 4 */}
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">
              Contact
            </h4>
            <p className="text-sm text-slate-400">United States</p>
            <p className="text-sm text-slate-400 mt-1">
              <a
                href="mailto:support@buildbright.app"
                className="hover:text-white underline"
              >
                support@buildbright.app
              </a>
            </p>
            <Link
              to="/get-quotes"
              className="text-sm mt-2 inline-block text-amber-300 hover:text-amber-200"
            >
              “Submit Project Request”
            </Link>
          </div>
        </div>

        <div className="mt-10 border-t border-zinc-800/5 pt-6 text-center">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} BuildBright. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export { Footer };

